import { useSubscription } from '@apollo/client';
import React from 'react';

import { useApiClient } from '@eluve/api-client-provider';
import { TooltipLabel } from '@eluve/blocks';
import { NewButton } from '@eluve/components';
import { useAppointmentContext } from '@eluve/frontend-appointment-hooks';
import { pendingTranscriptionFilesSubscriptions } from '@eluve/frontend-feature-appointment';

export const AppointmentRerunTranscriptionButton: React.FC = () => {
  const { appointmentId, tenantId } = useAppointmentContext();

  const apiClient = useApiClient();

  const handleRerunTranscription = async () => {
    apiClient.transcription.batchTranscribe({
      params: {
        tenantId,
      },
      body: {
        appointmentId,
      },
    });
  };

  const { data: pendingFiles } = useSubscription(
    pendingTranscriptionFilesSubscriptions,
    {
      variables: { tenantId, id: appointmentId },
    },
  );

  const pendingFilesCount =
    pendingFiles?.appointmentsByPk?.appointmentFiles?.length ?? 0;

  return (
    <TooltipLabel
      label={`${pendingFilesCount === 0 ? 'Rerun transcription on audio file' : 'Currently transcribing audio file'}`}
    >
      <NewButton
        type="outlineSubtle"
        onClick={handleRerunTranscription}
        icon={{ name: 'RefreshCw' }}
        disabled={pendingFilesCount > 0}
      />
    </TooltipLabel>
  );
};
